export default __webpack_public_path__ + "static/media/19.779e41cb.png";